import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Message } from 'primeng/api';
import { SourceAuthoritesAfterAuthenticationService } from 'src/app/services/auth/source-authorites-after-authentication.service';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { environment } from 'src/environments/environment';
export const ROLE_COURTIER="ROLE_COURTIER";
@Component({
  selector: 'app-mes-remboursements',
  templateUrl: './mes-remboursements.component.html',
  styleUrls: ['./mes-remboursements.component.scss']
})

export class MesRemboursementsComponent {
  configuration = this.configurationService.get();
  protected isACourtier = false;
  protected showBtnExtraction = true;
  protected enableErrorMessageCourtier: Message[];

  constructor(private readonly translate: TranslateService, protected sourceAuh: SourceAuthoritesAfterAuthenticationService, private readonly configurationService: ConfigurationService) {
    this.isFromCourtier()
  }
  private showCourtierMessage() {
    this.translate.get('mes-remboursements.confidentialite.detail').subscribe((details)=>{
      this.enableErrorMessageCourtier = [
        { severity: 'error', summary: this.translate.instant('mes-remboursements.confidentialite.summary'), detail:details }
      ];
    })
    
  }
  private isFromCourtier() {
      if(this.sourceAuh.accessDenied) {
          if ( !this.configuration.showRemboursement){
              this.showCourtierMessage();
          }else {
              this.showBtnExtraction = !this.configuration.showRemboursement;
          }
      }
  }
}
